var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "external-api-field" }, [
    _c("div", { staticClass: "header-field" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("h4", { staticClass: "title-field" }, [
          _vm._v(_vm._s(_vm.type === "before" ? "Before" : "After") + " Action")
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "close-modal", on: { click: _vm.closeModal } }, [
        _vm._v("\n      ×\n    ")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "external-api-content external-api-content--fullscreen" },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { md: "8" } }, [
              _c(
                "div",
                { staticClass: "configuration-section" },
                [
                  _c("h4", { staticClass: "configuration-section-title" }, [
                    _vm._v("\n            Custom Condition\n          ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-form",
                    [
                      _c("label", [_vm._v(" Script ")]),
                      _vm._v(" "),
                      _vm.type === "before" && _vm.showEditor
                        ? _c("j-monaco-editor", {
                            ref: "script",
                            attrs: {
                              value: _vm.dataSetup.script_before,
                              height: "calc(90vh - 200px)"
                            }
                          })
                        : _vm.type === "after" && _vm.showEditor
                        ? _c("j-monaco-editor", {
                            ref: "script",
                            attrs: {
                              value: _vm.dataSetup.script,
                              height: "calc(90vh - 200px)"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "b-col",
              { staticClass: "external-api-content__item", attrs: { md: "4" } },
              [
                _vm.type === "before"
                  ? _c(
                      "div",
                      { staticClass: "configuration-section" },
                      [
                        _c(
                          "h4",
                          { staticClass: "configuration-section-title" },
                          [
                            _vm._v(
                              "\n            Custom Message confirmation\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "configuration-section-desc" }, [
                          _vm._v(
                            "\n            Show message confirmation before executing the action\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "div-confirmation-message" }, [
                          _c(
                            "div",
                            {
                              staticClass: "type",
                              class: {
                                "type--active":
                                  _vm.confirmationMessageType === "static"
                              },
                              on: {
                                click: function($event) {
                                  _vm.setConfirmationMessageType("static")
                                }
                              }
                            },
                            [_vm._v("\n              Static\n            ")]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "type",
                              class: {
                                "type--active":
                                  _vm.confirmationMessageType === "dynamic"
                              },
                              on: {
                                click: function($event) {
                                  _vm.setConfirmationMessageType("dynamic")
                                }
                              }
                            },
                            [_vm._v("\n              Dynamic\n            ")]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.dataSetup.is_use_confirmation_message &&
                        _vm.confirmationMessageType === "static"
                          ? _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup.custom_confirmation_message
                                      .$error
                                }
                              },
                              [
                                _c("label", [_vm._v("Static custom message")]),
                                _vm._v(" "),
                                _c("j-input", {
                                  attrs: {
                                    "error-required": false,
                                    placeholder:
                                      "Enter static custom confirmation message"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup.custom_confirmation_message,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "custom_confirmation_message",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.custom_confirmation_message"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataSetup.is_use_confirmation_message &&
                        _vm.confirmationMessageType === "dynamic"
                          ? _c(
                              "b-form",
                              {
                                class: {
                                  "error-input":
                                    _vm.$v.dataSetup
                                      .dynamic_confirmation_message.$error
                                }
                              },
                              [
                                _c("label", [
                                  _vm._v("Function dynamic custom message")
                                ]),
                                _vm._v(" "),
                                _c("j-single-select", {
                                  attrs: {
                                    options: _vm.listFunction,
                                    "error-required": false,
                                    placeholder:
                                      "Select function dynamic custom message",
                                    label: "name"
                                  },
                                  model: {
                                    value:
                                      _vm.dataSetup
                                        .dynamic_confirmation_message,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.dataSetup,
                                        "dynamic_confirmation_message",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "dataSetup.dynamic_confirmation_message"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.dataSetup.is_use_confirmation_message &&
                        _vm.confirmationMessageType === "dynamic"
                          ? _c(
                              "b-form",
                              [
                                _c("label", [_vm._v(" Params ")]),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.dataSetup
                                    .dynamic_confirmation_message_params,
                                  function(data, index) {
                                    return _c(
                                      "div",
                                      { key: index, staticClass: "form-list" },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: data.variable,
                                              expression: "data.variable"
                                            }
                                          ],
                                          staticClass: "name",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Variable"
                                          },
                                          domProps: { value: data.variable },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                data,
                                                "variable",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: data.value,
                                              expression: "data.value"
                                            }
                                          ],
                                          staticClass: "value",
                                          attrs: {
                                            type: "text",
                                            placeholder: "Value"
                                          },
                                          domProps: { value: data.value },
                                          on: {
                                            input: function($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                data,
                                                "value",
                                                $event.target.value
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("i", {
                                          staticClass: "fa fa-trash",
                                          on: {
                                            click: function($event) {
                                              _vm.deleteParams(index)
                                            }
                                          }
                                        })
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-add-config",
                                    on: { click: _vm.addParams }
                                  },
                                  [
                                    _vm._v(
                                      "\n              + Add Params\n            "
                                    )
                                  ]
                                )
                              ],
                              2
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "before"
                  ? _c(
                      "div",
                      { staticClass: "configuration-section" },
                      [
                        _c(
                          "h4",
                          { staticClass: "configuration-section-title" },
                          [_vm._v("\n            Variables\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Variable Error Condition ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { "error-required": false },
                              model: {
                                value:
                                  _vm.dataSetup
                                    .container_script_before_is_not_valid,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "container_script_before_is_not_valid",
                                    $$v
                                  )
                                },
                                expression:
                                  "dataSetup.container_script_before_is_not_valid"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "small-text" }, [
                              _vm._v(
                                "\n              A boolean variable (true/false) indicating a condition error. If this variable contains true then it displays a modal error.\n            "
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Variable Message ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { "error-required": false },
                              model: {
                                value:
                                  _vm.dataSetup
                                    .container_script_before_is_not_valid_message,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "container_script_before_is_not_valid_message",
                                    $$v
                                  )
                                },
                                expression:
                                  "dataSetup.container_script_before_is_not_valid_message"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "small-text" }, [
                              _vm._v(
                                "\n              A variable containing a message to be displayed in a modal error.\n            "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.type === "after"
                  ? _c(
                      "div",
                      { staticClass: "configuration-section" },
                      [
                        _c(
                          "h4",
                          { staticClass: "configuration-section-title" },
                          [_vm._v("\n            Variables\n          ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Variable Message ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { "error-required": false },
                              model: {
                                value: _vm.dataSetup.variable_message,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "variable_message",
                                    $$v
                                  )
                                },
                                expression: "dataSetup.variable_message"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "small-text" }, [
                              _vm._v(
                                "\n              A variable containing a message to be displayed in a modal error.\n            "
                              )
                            ])
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-form",
                          [
                            _c("label", [_vm._v(" Variable Redirect ")]),
                            _vm._v(" "),
                            _c("j-input", {
                              attrs: { "error-required": false },
                              model: {
                                value: _vm.dataSetup.variable_redirect,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.dataSetup,
                                    "variable_redirect",
                                    $$v
                                  )
                                },
                                expression: "dataSetup.variable_redirect"
                              }
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "small-text" }, [
                              _vm._v(
                                "\n              Variable containing detailed information for page redirect.\n            "
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "external-api-footer" }, [
      _c(
        "button",
        { staticClass: "button-border mr-2", on: { click: _vm.closeModal } },
        [_vm._v("\n      Close\n    ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "button-blue", on: { click: _vm.submitForm } },
        [_vm._v("\n      Set\n    ")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-ext-api" }, [
      _c("img", {
        attrs: { src: require("@/assets/new-form-ui/icon/script-action.svg") }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96acee10", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96acee10","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalScriptBeforeAfterField.vue
// module id = null
// module chunks = 